import { FirmContext } from "../contexts/AuthContext";

// To access only super admin and super analyst.
export const canViewUnresolvedCaseErrors = (
  firmContext: FirmContext | null | undefined
): boolean => {
  if (!firmContext?.permissions) return false;

  if (firmContext.permissions.super_admin) return true;

  return Boolean(
    firmContext.permissions.organization_access?.all &&
    firmContext.permissions.case_actions?.resolve_error
  );
};
